<template>
    <tab
        :index="tab"
        :loginRequired="loginRequired"
        :iframeDisplay="true"
        :init="init"
    />
</template>

<script>
import tab from '../tab.vue';

export default {
    components: {
        tab
    },
    head() {
        return {};
    },
    data() {
        return {
            tab: '',
            tabName: this.$getRoute(this.$route).name,
            tabUrl: this.$getRoute(this.$route).fullPath,
            loginRequired: false,
            height: 850,
            isMaintenance: false
        };
    },
    computed: {
    },
    methods: {
        async init() {
            if (this.tab === '') {
                return;
            }
            this.tabUrl = this.$getRoute(this.$route).fullPath;
            if (!this.$store.state.maintenance.enable) {
                // remove old iframe
                this.$store.dispatch('updateIframe', {
                    loaded: false,
                    height: this.height,
                    tab: this.tab,
                    tabName: this.tabName,
                    tabUrl: this.tabUrl
                });
                this.$store.dispatch('updateIframeUrl', '');
                const result = await this.getIframeUrl();
                if ((result && result.status === 'OK')) {
                    if (this.$store.state.device === 'mobile') {
                        if (this.eventId) {
                            result.data.url = `${result.data.url}&eventId=${this.eventId}`;
                        }
                        if (this.matchId) {
                            result.data.url = `${result.data.url}&matchId=${this.matchId}`;
                        }
                        window.location.href = result.data.url;
                        return;
                    }
                    this.$store.dispatch('updateIframe', {
                        loaded: false,
                        height: this.height,
                        tab: this.tab,
                        tabName: this.tabName,
                        tabUrl: this.tabUrl
                    });
                    if (this.eventId) {
                        result.data.url = `${result.data.url}&eventId=${this.eventId}`;
                    }
                    if (this.matchId) {
                        result.data.url = `${result.data.url}&matchId=${this.matchId}`;
                    }
                    if (result.data.maintenance) {
                        this.$store.dispatch('updateIframeUrl', `${window.location.origin}/bao-tri`);
                    } else {
                        this.$store.dispatch('updateIframeUrl', result.data.url);
                    }
                } else {
                    this.$router.push('/');
                    this.$alertSystemMaintain();
                }
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            // this.calHeight();
        });
    }
};
</script>
